import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({ children, className = '', onClick }) => {
  return (
    <div
      onClick={onClick}
      className={`bg-surface-card-light dark:bg-surface-card-dark border border-surface-border-light dark:border-surface-border-dark rounded-xl shadow-soft transition-all duration-200 ${onClick ? 'cursor-pointer hover:shadow-elevated hover:-translate-y-0.5' : ''} ${className}`}
    >
      {children}
    </div>
  );
};

export const CardHeader: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => (
  <div
    className={`px-6 py-5 border-b border-surface-border-light dark:border-surface-border-dark ${className}`}
  >
    {children}
  </div>
);

export const CardContent: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => <div className={`px-6 py-5 ${className}`}>{children}</div>;

export const CardFooter: React.FC<{ children: React.ReactNode; className?: string }> = ({
  children,
  className = '',
}) => (
  <div
    className={`px-6 py-4 bg-surface-2-light dark:bg-surface-2-dark rounded-b-xl border-t border-surface-border-light dark:border-surface-border-dark ${className}`}
  >
    {children}
  </div>
);
